import { Upload, message } from 'antd';
import ImgCrop from 'antd-img-crop';
import { useState } from 'react';
import { useFetch }  from '../../services/ApiService';

const ImageUploader = ({ className, setImageId, uploadText }) => {
    const { fetchApi } = useFetch();
    
    const [fileList, setFileList] = useState([])
    

    const onChange = ({ fileList: newFileList }) => {
        setFileList(newFileList);
    };
    
    const onPreview = async (file) => {
        let src = file.url;
        if (!src) {
            src = await new Promise((resolve) => {
                const reader = new FileReader();
                reader.readAsDataURL(file.originFileObj);
                reader.onload = () => resolve(reader.result);
            });
        }
        const image = new Image();
        image.src = src;
        const imgWindow = window.open(src);
        imgWindow?.document.write(image.outerHTML);

    };

    const handleAction = async ({ file, onSuccess }) => {
        let data = new FormData();
        data.append('attachment', file);

        await fetchApi('/api/attachment', 'POST', data, true)
            .then((res) => {
                setImageId(res.id);
                onSuccess("ok");
            })
            .catch((error) => {
                message.error('Error while uploading image.')
                console.log(error);
            });

        /* setTimeout(() => {
            onSuccess("ok");
        }, 0); */
    }
    return (
        
        <ImgCrop rotationSlider onModalOk={() => { }}>
            <Upload
                className={className}
                customRequest={handleAction}
                listType="picture-card"
                fileList={fileList}
                onChange={onChange}
                onPreview={onPreview}
            >
                {fileList.length < 1 && uploadText}
            </Upload>
        </ImgCrop>
    )
};
export default ImageUploader;


ImageUploader.defaultProps = {
    uploadText: '+ Upload',
    className: '',
    fileList: [],
    setFileList: () => { }
}